import { utils } from '@hh/global.js'
const { reRenderShopifySections, fetchCartHTML } = utils

class RepAIManager extends HTMLElement {
  constructor() {
    super()

    this.repInitialized = false
    this.repTriggerFlowInitialized = false
    this.repOnInitialized = false

    this.customCSSTemplate = this.querySelector('[data-repai-injected-css]')
    this.chatBanner = this.querySelector('.gifting-concierge-chat-banner')
    this.giftBanner = this.querySelector('.gifting-concierge-gift-banner')
    this.giftBannerCloseButton = this.querySelector('[data-gift-banner-close]')

    this.handleGiftBannerClose = this.handleGiftBannerClose.bind(this)
  }

  connectedCallback() {
    // Prevent widget from auto-opening on load
    window.sessionStorage.removeItem('vfIsOpen')

    this.giftBannerCloseButton?.addEventListener(
      'click',
      this.handleGiftBannerClose
    )
    
    this.intervalIterations = 0
    this.interval = setInterval(() => {
      this.awaitGlobalRepMethods()

      this.intervalIterations += 1
      if (this.intervalIterations > 100) {
        clearInterval(this.interval)
      }
    }, 100)

    this.initBanners()
  }

  disconnectedCallback() {
    this.giftBannerCloseButton?.removeEventListener(
      'click',
      this.handleGiftBannerClose
    )
    
    clearInterval(this.interval)
  }

  awaitGlobalRepMethods() {
    if (
      this.repInitialized &&
      this.repTriggerFlowInitialized &&
      this.repOnInitialized
    ) {
      clearInterval(this.interval)
    }

    if (!this.repInitialized && window.rep) {
      this.injectCustomStyles()
      this.repInitialized = true
    }

    if (
      !this.repTriggerFlowInitialized &&
      typeof window.rep?.triggerFlow === 'function'
    ) {
      // const flowKey = this.getAttribute('data-custom-flow-key')
      // if (flowKey) {
      //   this.triggerCustomFlow(flowKey)
      // }

      const mode = this.getAttribute('data-mode')
      if (mode === 'gifting-concierge-page') {
        window.rep?.refreshSession()
      }

      const fullScreenEnabled = this.getAttribute('data-full-screen-enabled') === 'true'
      window.rep?.fullScreenEnabled(fullScreenEnabled);

      this.repTriggerFlowInitialized = true
    }

    if (!this.repOnInitialized && typeof window.rep?.on === 'function') {
      this.setupAddToCartListener()
      this.repOnInitialized = true
    }
  }

  injectCustomStyles() {
    const container = document.querySelector('#repWebClientContainer')
    if (
      container?.shadowRoot &&
      !container.shadowRoot.querySelector('[data-merchant-css]')
    ) {
      const style = document.createElement('style')
      style.textContent = this.customCSSTemplate?.innerHTML || ''
      style.setAttribute('data-merchant-css', 'true')
      container.shadowRoot.appendChild(style)
      return true
    }
    return false
  }

  triggerCustomFlow(flowKey) {
    window.rep.triggerFlow({
      flowType: 'ENTRY_FLOW',
      flowKey,
      chatopened: true,
    })
  }

  setupAddToCartListener() {
    window.rep.on('updateCartByProducts', (e) => {
      setTimeout(async () => {
        const updatedCartHTMLResponse = await fetchCartHTML()
        if (updatedCartHTMLResponse) {
          reRenderShopifySections({ sections: updatedCartHTMLResponse })
          window.Nosto?.reloadCart()

          setTimeout(() => {
            document.querySelector('hh-mini-cart')?.open()
          }, 0)
        }
      }, 2000) // Delay because updateCartByProducts fires before cart is updated
    })
  }

  updateBannerDisplayState() {
    this.chatBanner?.classList.add('hide')
    this.chatBanner?.setAttribute('inert', '')

    this.giftBanner?.classList.add('revealed')

    document.documentElement.style.setProperty(
      '--gifting-concierge-toggle-icon-display-override',
      'block'
    )
  }

  initBanners() {
    const viewedUntilTimeStamp = window.localStorage.getItem(
      'gifting_concierge_viewed_until'
    )
    if (viewedUntilTimeStamp && viewedUntilTimeStamp > Date.now()) {
      this.updateBannerDisplayState()
    } else {
      this.chatBanner?.classList.remove('hidden')
      setTimeout(() => {
        this.updateBannerDisplayState()
        const duration = 7 * 24 * 60 * 60 * 1000 // 1 week
        window.localStorage.setItem(
          'gifting_concierge_viewed_until',
          Date.now() + duration
        )
      }, 5000)
    }
  }

  handleGiftBannerClose() {
    this.giftBanner?.classList.add('hidden')
  }
}

customElements.define('hh-repai-manager', RepAIManager)
